import { useSystemConfiguration } from '@/hooks/theme/useSystemConfiguration';
import useAuthForm from '../useAuthForm';
import { UseAuthFormStateProps } from './props';
import { AuthStep } from '@/enums/auth/authStep';
import { OriginId } from '@starsoft/common/models/origin/id';
import { UserIdentity } from '@starsoft/common/models';
import { UserIdentityStatus } from '@starsoft/common/enums';
import { Path } from 'react-hook-form';
import { KycCheckpointId } from '@/enums/kycCheckpointId';

export function useAuthFormState<T>({ methods }: UseAuthFormStateProps<T>) {
  const {
    isInvalidForm,
    step,
    kycCheckpointId,
    useUserIdentityValidateByOriginIdQuery: {
      data: personalIdentityLookup,
      error: errorPersonalIdentityLookup,
    },
  } = useAuthForm({ methods });
  const { watch } = methods;

  const { originId } = useSystemConfiguration();
  const identifier = watch('identity.identifier' as Path<T>);
  const code = watch('code' as Path<T>);

  switch (step) {
    case AuthStep.Form:
      return isInvalidForm;
    case AuthStep.Kyc:
      switch (originId) {
        case OriginId.Brazil:
          switch (BigInt(kycCheckpointId)) {
            case KycCheckpointId.Identity:
            case KycCheckpointId.VerifiedTaxId:
              return (
                !identifier ||
                (personalIdentityLookup as unknown as UserIdentity)?.status ==
                  UserIdentityStatus.Invalid ||
                !!errorPersonalIdentityLookup
              );
            case KycCheckpointId.DocumentSubmission:
              return true;
            case KycCheckpointId.VerifiedEmail:
              return !!code && typeof code === 'string' && code.length === 6;
          }
      }
  }
}
